import equals from 'fast-deep-equal';
import React from 'react';

import { format } from '@eika-infrastruktur/date';
import { LinkButton } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import { IconTypes } from '@eika/icon';

import { TransactionSubmitWrapper } from '../../../../../../components/TransactionForm';
import { PaymentState } from '../../../../../../components/transaction/Payment/form/state';
import useTranslation from '../../../../../../hooks/useTranslation';
import { useOutboxFormContext } from '../../hooks';

interface Props {
    onClose: () => void;
    onDelete: () => void;
    initialState: PaymentState;
    onMutate: (event: React.FormEvent<HTMLButtonElement>) => void;
    onSign(): void;
    editLoading: boolean;
}

const normalize = ({ note, fromAccount, toAccount, amount, paymentDate, ownText, receiptType }: PaymentState) => ({
    note,
    ownText,
    fromAccount: fromAccount?.value,
    toAccount: toAccount?.accountNumber.value,
    amount,
    receiptType,
    paymentDate: paymentDate ? format(paymentDate, 'dd/MM/yy') : '',
});

const OutboxSubmitWrapper: React.FC<Props> = ({ onClose, onDelete, initialState, onMutate, onSign, editLoading }) => {
    const translated = useTranslation();
    const form = useOutboxFormContext();
    const isDirty = !equals(normalize(form.state), normalize(initialState));

    return (
        <TransactionSubmitWrapper className="edit-outbox-modal-content__buttons">
            <div className="edit-outbox-modal-content__button-row">
                <ButtonWithSpinner
                    className="future-payment-details__pay-now-btn"
                    buttonType="negative"
                    disabled={editLoading}
                    onClick={onClose}
                >
                    {translated.cancel}
                </ButtonWithSpinner>
                {isDirty ? (
                    <ButtonWithSpinner
                        className="future-payment-details__pay-now-btn"
                        buttonType="positive"
                        showSpinner={editLoading}
                        onClick={onMutate}
                    >
                        {translated.outbox.saveChanges}
                    </ButtonWithSpinner>
                ) : (
                    <ButtonWithSpinner
                        className="future-payment-details__pay-now-btn"
                        buttonType="positive"
                        showSpinner={editLoading}
                        onClick={onSign}
                    >
                        {translated.payNow}
                    </ButtonWithSpinner>
                )}
            </div>
            <div className="edit-outbox-modal-content__button-row" data-testid="delete-outbox-payment-button">
                <LinkButton icon={IconTypes.SLETT_24} onClick={onDelete} hidden={editLoading}>
                    {translated.outbox.deletePayment}
                </LinkButton>
            </div>
        </TransactionSubmitWrapper>
    );
};

export default OutboxSubmitWrapper;
